'use client';

import React, { createContext, useContext } from 'react';

export type AppUser = {
  id: string;
  auth_user_id: string;
  name: string;
  role: string[];
  language?: string | null;
  company_id?: string | null;
  canteen_id?: string | null;
  tenant_id?: string | null;
  email?: string | null;
  internal_number?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  status?: string | null;
  tenant?: {
    id: string;
    name: string;
    active: boolean;
  } | null;
};
type AppUserContextType = {
  user: AppUser | null | undefined;
};

const AppUserContext = createContext<AppUserContextType>({ user: undefined });

export default function AppUserProvider({
  children,
  user,
}: {
  children: React.ReactNode;
  user: AppUser | null | undefined;
}) {
  return <AppUserContext.Provider value={{ user }}>{children}</AppUserContext.Provider>;
}

export function useAppUser() {
  const context = useContext(AppUserContext);
  if (context === undefined) {
    throw new Error('useAppUser must be used within an AppUserProvider');
  }
  return context;
}
